// const { triggerCounters } = require("./components/animatedCounters");
import Swiper from "swiper/bundle";
import { triggerCounters } from "../js/components/animatedCounters";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

function homeJs() {
	let currentOrientation =
		window.innerWidth > window.innerHeight ? "landscape" : "portrait";

	const debounce = (func, delay) => {
		let timeoutId;
		return (...args) => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
			timeoutId = setTimeout(() => {
				func.apply(null, args);
			}, delay);
		};
	};

	const handleResize = () => {
		const newOrientation =
			window.innerWidth > window.innerHeight ? "landscape" : "portrait";
		if (newOrientation !== currentOrientation) {
			kill();
			homeJs();
			currentOrientation = newOrientation;
		}
	};

	window.addEventListener("resize", debounce(handleResize, 500));
	triggerCounters();

	var div = document.querySelector(".richVideo");
	var parent = document.querySelector(".pinDiv");

	var distanceFromTop = div.offsetTop - parent.offsetTop;

	// let options = {
	// 	root: document.querySelector(".fixed-pos-b"),
	// 	rootMargin: "20px",
	// 	threshold: 1.0,
	//   };

	// let hr = document.querySelector(".fixed-pos-b");
	// const sticky = document.querySelector(".fixed-pos-w");
	// const ob = new IntersectionObserver(obCallback);

	// function obCallback(payload) {
	// 	if (payload[0].boundingClientRect.y < 0) {
	// 		sticky.classList.add('visible');
	// 	}
	// 	else {
	// 		sticky.classList.remove('visible');
	// 	}
	// }
	// ob.observe(hr);


	setTimeout(() => {
		// let videoTl = gsap.timeline();
		// videoTl.pause(0);
		// videoTl.to(".pinDiv", { color: "white" }, "start");

		gsap.to(".pinDiv .richVideo", {
			scrollTrigger: {
				trigger: ".pinDiv .richVideo",
				start: "top 80%",
				end: "top 10%",
				scrub: true,
			},
			ease: "power2.inOut",
			clipPath: "polygon(0 0, 100% 0, 100% 25%, 100% 100%, 0 100%, 0 75%)",
			width: "100%",
		});

	}, 300);
	let firstScroll = false;
	// document.addEventListener("scroll", () => {
	// 	if (firstScroll === false) {
	// 		setTimeout(() => {
	// 			gsap.to(".fixed-pos-b", {
	// 			scrollTrigger: {
	// 				trigger: ".fixed-pos-b",
	// 				pin: true,
	// 				scrub: true,
	// 				pinSpacing: false,
	// 				start: "top top", // Trigger when the top of the element reaches the top of the viewport
	// 				// end: "bottom center",
	// 				width: "100%"
	// 				// end: `500px`, // Pin the element for the next 2000px
	// 				// scrub: true, // Smoothly animate the property changes as you scroll
	// 				// toggleActions: "play pause resume reset",
	// 				// pin: true, // Pin the element
	// 				// endTrigger: "bottom bottom",

	// 			}

	// 			});
	// 		}, 1000);
	// 		firstScroll = true;
	// 	}
	// });


	const switchMenu = document.querySelector(".transMenu");
	const el = document.querySelector("#main-header");
	const mobserver = new IntersectionObserver(
		([entry]) => {
			el.classList.toggle("switch", !entry.isIntersecting);
		},
		{ threshold: [0] }
	);

	const infoDelays = document.querySelectorAll(".info-delay");
	infoDelays &&
		infoDelays.forEach(
			(elem, index) => (elem.style.transitionDelay = `${index * 0.3}s`)
		);

	mobserver.observe(switchMenu);

	const infoGraphicSliderSlides = document.querySelectorAll('.infoGraphicSlider .swiper-slide')
	const infoSwiperWrapper = document.querySelector('.infoGraphicSlider .swiper-wrapper');
	infoSwiperWrapper.innerHTML = "";
	infoGraphicSliderSlides.forEach(elem => infoSwiperWrapper.append(elem));

	setTimeout(() => {
		let infoGraphicSlider = new Swiper(".infoGraphicSlider", {
			direction: "vertical",
			slidesPerView: 1,
			spaceBetween: 30,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			speed: 700,
			mousewheel: {
				releaseOnEdges: true,
			},
		});

		infoGraphicSlider.mousewheel.disable()

		gsap.to(".afterFullscreenImage", {
			scrollTrigger: {
				trigger: ".afterFullscreenImage",
				start: "top top", // Trigger when the top of the element reaches the top of the viewport
				end: `+=1000px`, // Pin the element for the next 2000px
				scrub: 1.5, // Smoothly animate the property changes as you scroll
				// toggleActions: "play pause resume reset",
				pin: true, // Pin the element
				// markers: true, // Optional: add markers to debug and visualize the trigger area
				// {releaseOnEdges}
				onLeave: () => {
					infoGraphicSlider.mousewheel.disable()
				},
				onEnter: () => {
					infoGraphicSlider.mousewheel.enable()
					// infoGraphicSlider.extendDefaults({
					// 	mousewheel: {
					// 		releaseOnEdges: true,
					// 	},
					// });
				},
				onEnterBack: () => {
					infoGraphicSlider.mousewheel.enable()
					// infoGraphicSlider.extendDefaults({
					// 	mousewheel: {
					// 		releaseOnEdges: true,
					// 	},
					// });
				},
				onLeaveBack: () => {
					infoGraphicSlider.mousewheel.disable()
				},
			},
			// color: "white",
		});

	}, 100)
}

export default homeJs;
